/**
 * Money helpers. Everything is GBP, ex-VAT.
 *
 * All arithmetic rounds to whole pence at the LINE level and then sums, which is
 * what HubSpot line items and Wave9 invoices do — summing unrounded values and
 * rounding at the end drifts by a penny or two on big quotes and makes the
 * portal total disagree with the deal.
 */

/** Round to 2dp, half away from zero, immune to binary float dust (1.005 -> 1.01). */
export function round2(n: number): number {
  if (!Number.isFinite(n)) return 0
  const scaled = n * 100
  const nudged = scaled >= 0 ? scaled + 1e-9 : scaled - 1e-9
  return Math.round(nudged) / 100
}

/** Line total = unit price x quantity, rounded to pence. */
export function lineTotal(unitPrice: number, qty: number): number {
  return round2(unitPrice * qty)
}

const GBP = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function formatGBP(n: number): string {
  return GBP.format(round2(n))
}

/** "£1,200.00" with no pence when the amount is whole — for KPI tiles. */
export function formatGBPCompact(n: number): string {
  const v = round2(n)
  return Number.isInteger(v)
    ? new Intl.NumberFormat('en-GB', {
        style: 'currency', currency: 'GBP', maximumFractionDigits: 0,
      }).format(v)
    : GBP.format(v)
}

export function formatPct(fraction: number, dp = 1): string {
  return `${(fraction * 100).toFixed(dp)}%`
}
